"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCheckbox = exports.serializeCheckbox = void 0;
const serializeCheckbox = (item) => {
    return typeof item.data.checked === "boolean" ? `${item.data.checked}` : "";
};
exports.serializeCheckbox = serializeCheckbox;
const validateCheckbox = (item) => {
    if (!item.required || item.data.checked) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be checked." } };
};
exports.validateCheckbox = validateCheckbox;
//# sourceMappingURL=checkbox.js.map